export default "__VITE_ASSET__CfbWyhVq__"